
export default class UserTradingOffer {
  constructor($scope, $rootScope, UserService) {
    $scope.update_user = function() {
      $scope.updating_user = true;
      UserService.update($scope.user, null, null).then(function(data) {
        if (data.success) {
          $scope.updating_user = false;
          $rootScope.$broadcast('set_sidebar_data', [0, 1, [{
            type: 'percentage',
            value: data.offer_details_percentage
          }]]);
        }
      });
    };

    $scope.init = function() {
      $scope.user = window.user;
    };

    $scope.init();
  }
}

UserTradingOffer.$inject = ['$scope', '$rootScope', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-trading-offer.ctrl.js